export default __webpack_public_path__ + "static/media/black01.2c28eb58.jpg";